import { POI_CATEGORIES } from '../lib/pois'
import { useUi } from '../state/ui'

export default function DiscoverPanel() {
  const { poiCategories, togglePoiCategory } = useUi()

  return (
    <>
      <h2>Discover</h2>
      <p className="muted" style={{ margin: '0 2px 12px', lineHeight: 1.5 }}>
        Show outdoor highlights on the map, then tap a marker to route to it. Zoom in to load places.
      </p>
      <div className="sports" style={{ gridTemplateColumns: 'repeat(2, 1fr)' }}>
        {POI_CATEGORIES.map((c) => (
          <button
            key={c.id}
            className={poiCategories.includes(c.id) ? 'active' : ''}
            onClick={() => togglePoiCategory(c.id)}
          >
            <span style={{ fontSize: 20 }}>{c.icon}</span>
            {c.label}
          </button>
        ))}
      </div>
      <div className="hint">
        Community-mapped by OpenStreetMap contributors. Combine with the <b>Topo</b> or <b>Satellite</b> style (layers
        button on the map) to scout terrain.
      </div>
    </>
  )
}
